<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Yêu cầu hỗ trợ
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Lĩnh vực sửa chữa" prop="requestField">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.requestField"
                placeholder="Gõ tên để bắt đầu tìm kiếm"
                siz e="medium"
                filterable
                clearable
              >
                <el-option
                  v-for="item in requestFields"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên yêu cầu" prop="requestName">
              <el-input
                v-model="form.requestName"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Thời gian sửa chữa" prop="requestTime">
              <el-date-picker
                v-model="form.requestTime"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                type="datetime"
                placeholder="dd/MM/yyyy HH:mm"
                format="dd/MM/yyyy HH:mm"
                :prefix-icon="' '"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Địa điểm sửa chữa" prop="requestAddress">
              <el-input
                v-model="form.requestAddress"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Số điện thoại" prop="requestPhoneNumber">
              <el-input
                v-model="form.requestPhoneNumber"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="20"
                show-word-limit
                @change="isdnChanged"
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nội dung sửa chữa" prop="requestContent">
              <el-input
                type="textarea"
                v-model="form.requestContent"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import CustomDialog from "../../common/custom-dialog";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcFlowService from "../../../services/hcFlowService";
import constants from "../../../constants";
import moment from "moment";
import utils from "../../../services/utils";
import hanhchinhService from "../../../services/hanhchinhService";
import categoryService from "../../../services/categoryService";


export default {
  name: "hc-scn-create-dialog",
  mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin],
  props: ["isOpen"],
  components: {
    CustomDialog,
    VueCtkDateTimePicker
  },

  data() {
    return {
      startTime: moment(new Date()).format("DD/MM/YYYY HH:mm"),
      hcFlow: null,
      flowId: null,
      requestFields: [],
      rules: {
        requestField: null,
        requestName: null,
        requestTime: null,
        requestAddress: null,
        requestContent: null,
        requestPhoneNumber: null,
      },
      form: {
        requestField: null,
        requestName: null,
        requestTime: null,
        requestPhoneNumber: null,
        requestAddress: null,
        requestContent: null
      },
      flowCode: constants.HC_FLOW.FLOW_CODE.SUA_CHUA_NHO
    };
  },

  computed: {},

  watch: {},

  created() {
    this.initSelectOptions();
    this.initValidationRules();
    this.loadHcFlow();
    this.initForm();
  },


  methods: {

    initForm() {
      this.form.requestTime = new Date();
    },

    initSelectOptions() {
      return categoryService.findAllByCategoryGroupCode(constants.CATEGORY_GROUP_CODE.HC_SCN_LINH_VUC)
        .then(res => this.requestFields = res.data);
    },

    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternative(this.flowCode)
        .then(response => {
          this.hcFlow = response.data;
          this.flowId = this.hcFlow.id;
        });
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      this.rules.requestName = [defaultRequiredConstrains];
      this.rules.requestField = [defaultRequiredConstrains];
      this.rules.requestAddress = [defaultRequiredConstrains];
      let checkPhoneFormat = utils.buildPhoneValidationRule();
      this.rules.requestPhoneNumber = [{validator: checkPhoneFormat, trigger: "blur"}];
      this.rules.requestTime = [defaultRequiredConstrains];

    },

    isdnChanged() {
      this.form.requestPhoneNumber = utils.standardlizePhoneNumber(this.form.requestPhoneNumber);
    },

    standardlizePhoneNumber(value) {
      value = value.trim().replace(/\s+/g, "");
      if (value.length === 9) return "+84" + value;
      if (value.startsWith("0")) return "+84" + value.substring(1);
      if (value.startsWith("84")) return "+84" + value.substring(2);
      if (!value.startsWith("+84")) return "+84" + value;
      return value;
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    convertToSubmitForm() {
      return {
        requestField: this.form.requestField,
        requestName: this.form.requestName,
        requestAddress: this.form.requestAddress,
        requestTime: this.form.requestTime.getTime(),
        requestPhoneNumber : this.form.requestPhoneNumber,
        requestContent: this.form.requestContent,
        flowId: this.hcFlow ? this.hcFlow.id : null
      };
    },

    submit() {
      this.validateForm()
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hanhchinhService
            .registerSCNRequest(submitForm)
            .then(response => response.data);
        })
        .then(hcCaseCommands => {
          this.$message.success(
            errorMessageFilter({
              errorCode: "hcSCN.insertSuccess"
            })
          );
          this.$emit("insertSuccess", {result: hcCaseCommands});
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/suachuanho/hc-scn-create-dialog.vue